export const TreatmentResponseGroup = {
  MissingGrade: 'MissingGrade',
  MissingSkill: 'MissingSkill',
  MissingAvailability: 'MissingAvailability',
  TimeSlotsAlreadyOccupied: 'TimeSlotsAlreadyOccupied',
  OutsideOfMilleageCap: 'OutsideOfMilleageCap',
  BestMatch: 'BestMatch',
  ExcludedClinician: 'ExcludedClinician',
};
